module.exports = __webpack_public_path__ + "static/media/step3.25499cb1.png";